function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { AdobeTarget } from "./AdobeTarget";
import logger from "../../logger";
// Add Cache v2 support
import { withLPEHOC } from "../LPEHOC";
import { getFlag, getPersonalizationClientId } from "../../utils/ld-cache";
import useURL from "../../hooks/useURL";
var defaultMapPropsToName = function(_, name) {
    return name;
};
var defaultMapPropsToParameters = function(_, parameters) {
    return parameters;
};
var defaultMapPropsToProfileParameters = function(_, profileParameters) {
    return profileParameters;
};
var withTargetMbox = function(param) {
    var mbox = param.mbox, mboxParams = param.mboxParams, mapPropsToMboxName = param.mapPropsToMboxName, mapPropsToMboxParams = param.mapPropsToMboxParams, mapToChildren = param.mapToChildren, name = param.name, parameters = param.parameters, profileParameters = param.profileParameters, overrideResponseProps = param.overrideResponseProps, _param_mapPropsToName = param.mapPropsToName, mapPropsToName = _param_mapPropsToName === void 0 ? defaultMapPropsToName : _param_mapPropsToName, _param_mapPropsToParameters = param.mapPropsToParameters, mapPropsToParameters = _param_mapPropsToParameters === void 0 ? defaultMapPropsToParameters : _param_mapPropsToParameters, _param_mapPropsToProfileParameters = param.mapPropsToProfileParameters, mapPropsToProfileParameters = _param_mapPropsToProfileParameters === void 0 ? defaultMapPropsToProfileParameters : _param_mapPropsToProfileParameters, _param_forwardRef = param.forwardRef, forwardRef = _param_forwardRef === void 0 ? false : _param_forwardRef, disableFoocMask = param.disableFoocMask;
    // TODO remove deprecated props
    if (mbox || mboxParams || mapPropsToMboxName || mapPropsToMboxParams || mapToChildren) {
        logger.warn('withTargetMbox "' + (mbox || name) + '" props (mbox, mboxParams, mapPropsToMboxName, mapPropsToMboxParams, mapToChildren) have been deprecated\nplease use props (name, parameters, mapPropsToName, mapPropsToParameters, overrideResponseProps) respectfully.');
    }
    if (!name) name = mbox; // eslint-disable-line no-param-reassign
    if (!parameters) parameters = mboxParams; // eslint-disable-line no-param-reassign
    if (!mapPropsToName) mapPropsToName = mapPropsToMboxName; // eslint-disable-line no-param-reassign
    if (!mapPropsToParameters) mapPropsToParameters = mapPropsToMboxParams; // eslint-disable-line no-param-reassign
    if (!overrideResponseProps) overrideResponseProps = mapToChildren; // eslint-disable-line no-param-reassign
    // END TO
    if (typeof name !== "string" || name.length === 0) {
        logger.error("Expected parameter `name` to be a string with length > 0");
        return function(Component) {
            return Component;
        };
    }
    return function(WrappedComponent) {
        var displayName = "withTargetMbox";
        if (forwardRef) {
            var Forwarded = /*#__PURE__*/ React.forwardRef(function(props, ref) {
                var mappedName = useMemo(function() {
                    return mapPropsToName(props, name);
                }, [
                    props
                ]);
                var mappedParameters = useMemo(function() {
                    return mapPropsToParameters(props, parameters);
                }, [
                    props
                ]);
                var mappedProfileParameters = useMemo(function() {
                    return mapPropsToProfileParameters(props, profileParameters);
                }, [
                    props
                ]);
                return(// essentially a wrapper component for the AdobeTarget wrapper
                /*#__PURE__*/ _jsx(AdobeTarget, {
                    name: mappedName,
                    parameters: mappedParameters,
                    profileParameters: mappedProfileParameters,
                    overrideResponseProps: overrideResponseProps,
                    disableFoocMask: disableFoocMask,
                    ref: ref,
                    children: /*#__PURE__*/ _jsx(WrappedComponent, _extends({}, props, {
                        ref: ref
                    }))
                }));
            });
            Forwarded.displayName = displayName;
            return Forwarded;
        }
        var NotForwarded = function(props) {
            var mappedName = useMemo(function() {
                return mapPropsToName(props, name);
            }, [
                props
            ]);
            var mappedParameters = useMemo(function() {
                return mapPropsToParameters(props, parameters);
            }, [
                props
            ]);
            var mappedProfileParameters = useMemo(function() {
                return mapPropsToProfileParameters(props, profileParameters);
            }, [
                props
            ]);
            // essentially a wrapper component for the AdobeTarget wrapper
            return /*#__PURE__*/ _jsx(AdobeTarget, _extends({}, props, {
                name: mappedName,
                parameters: mappedParameters,
                profileParameters: mappedProfileParameters,
                overrideResponseProps: overrideResponseProps,
                disableFoocMask: disableFoocMask,
                children: /*#__PURE__*/ _jsx(WrappedComponent, _extends({}, props))
            }));
        };
        NotForwarded.displayName = displayName;
        return NotForwarded;
    };
};
var withTargetMboxWithLPEHOC = function(config) {
    var withLegacy = withTargetMbox(config);
    var withCompatibility = withLPEHOC(function(props) {
        var url = useURL();
        var _config_mapPropsToName = config.mapPropsToName, mapPropsToName = _config_mapPropsToName === void 0 ? defaultMapPropsToName : _config_mapPropsToName, _config_mapPropsToParameters = config.mapPropsToParameters, mapPropsToParameters = _config_mapPropsToParameters === void 0 ? defaultMapPropsToParameters : _config_mapPropsToParameters, _config_mapPropsToProfileParameters = config.mapPropsToProfileParameters, mapPropsToProfileParameters = _config_mapPropsToProfileParameters === void 0 ? defaultMapPropsToProfileParameters : _config_mapPropsToProfileParameters, configName = config.name, configParameters = config.parameters, configProfileParameters = config.profileParameters, disableFoocMask = config.disableFoocMask, rest = _object_without_properties_loose(config, [
            "mapPropsToName",
            "mapPropsToParameters",
            "mapPropsToProfileParameters",
            "name",
            "parameters",
            "profileParameters",
            "disableFoocMask"
        ]);
        return useMemo(function() {
            // Emulate mapping logic from old WithTargetMbox
            var entryConfig = {
                name: mapPropsToName(props, configName),
                parameters: mapPropsToParameters(props, configParameters),
                profileParameters: mapPropsToProfileParameters(props, configProfileParameters),
                path: url
            };
            return _extends({}, rest, {
                config: entryConfig,
                foocMask: !disableFoocMask
            });
        }, // All other dependencies are static and wont change, or they will change every render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            props,
            url
        ]);
    });
    return function(Component) {
        var WrappedCompatibilityComponent = withCompatibility(Component);
        var WrappedLegacyComponent = withLegacy(Component);
        var WrappedComponent = /*#__PURE__*/ React.forwardRef(function(props, ref) {
            var useNewCache = getFlag("replace-lapel-legacy-cache", false, getPersonalizationClientId());
            if (useNewCache) {
                return /*#__PURE__*/ _jsx(WrappedCompatibilityComponent, _extends({}, props, {
                    ref: ref
                }));
            }
            return /*#__PURE__*/ _jsx(WrappedLegacyComponent, _extends({}, props, {
                ref: ref
            }));
        });
        WrappedComponent.displayName = "withTargetMboxCompatibility(" + (Component.displayName || Component.name || "Component") + ")";
        return WrappedComponent;
    };
};
export { withTargetMboxWithLPEHOC as withTargetMbox };

//# sourceMappingURL=WithTargetMbox.js.map